import { RoomMemberEvent } from 'matrix-js-sdk'
import type { MatrixEvent, RoomMember } from 'matrix-js-sdk'
import { startMatrixClient } from '@/modules/chat-matrix-fast/services/matrixClientLifecycle'

type MembershipListener = () => void

export function subscribeMatrixRoomMembership(
  roomId: string,
  onUpdate: MembershipListener,
): () => void {
  let matrixClient: Awaited<ReturnType<typeof startMatrixClient>> | undefined
  let stopped = false
  let debounceTimer: number | undefined

  const scheduleUpdate = () => {
    window.clearTimeout(debounceTimer)
    debounceTimer = window.setTimeout(() => {
      if (!stopped) {
        onUpdate()
      }
    }, 300)
  }

  const onMembership = (
    _event: MatrixEvent,
    member: RoomMember,
  ) => {
    if (member.roomId === roomId) {
      scheduleUpdate()
    }
  }

  void startMatrixClient().then(startedClient => {
    if (stopped) {
      return
    }

    matrixClient = startedClient
    matrixClient.on(RoomMemberEvent.Membership, onMembership)
  })

  return () => {
    stopped = true
    window.clearTimeout(debounceTimer)
    matrixClient?.removeListener(RoomMemberEvent.Membership, onMembership)
  }
}
